const {
	default: { breakMediumSmall },
} = require('../../../../js/sass-variables');
const { mediaQueryMin, trackGtm4 } = require('../../../../js/functions');

const ACTIVE = 'active';

module.exports = {
	init() {
		const news = this.root.getElementsByClassName('news-item');
		const latestLink = this.root.querySelector('.latest-press-releases--link');
		const widgetTitle = this.root.querySelector(
			'.latest-press-releases--title',
		).innerText;
		this.setCurrent(news[0]);
		latestLink.addEventListener('click', e => {
			trackGtm4({
				event: 'GA4_event_c_cta',
				widget_name: 'V3-Latest-press-release',
				widget_title: widgetTitle,
				link_text: e.target.innerHTML,
				link_url: e.target.href,
				button_type: '',
			});
		});
		Array.from(news).forEach(card => {
			const downloadButton = card.querySelector('.news-item--top-link');
			card.addEventListener('mouseover', () => {
				if (mediaQueryMin(breakMediumSmall)) {
					this.setCurrent(card);
				}
			});
			card.addEventListener('click', () => {
				const cardTitle = card.querySelector('.news-item--title').innerHTML;
				trackGtm4({
					event: 'GA4_event_c_cta',
					widget_name: 'V3-Latest-press-release',
					widget_title: widgetTitle,
					link_text: cardTitle,
					link_url: downloadButton.href,
					button_type: '',
				});
				this.handleClick(card);
			});
		});
	},
	setCurrent(current) {
		if (this.current) {
			this.current.classList.remove(ACTIVE);
		}
		this.current = current;
		this.current.classList.add(ACTIVE);
	},
	handleClick(card) {
		if (!mediaQueryMin(breakMediumSmall)) {
			const active = card.classList.contains(ACTIVE);
			if (active) this.jumpTo(card);
			else this.setCurrent(card);
		} else this.jumpTo(card);
	},
	jumpTo(card) {
		const link = card.querySelector('.news-item--top-link');
		if (link) window.location.href = link.href;
	},
};
